import styled from "styled-components";
import { devices } from "../../utilities/responsive";

export const ArticleCard = styled.div<{ isOneArticle?: boolean }>`
   display: grid;
   align-items: stretch;

  .card__image {
    height: "max-content";
    overflow: hidden;

    @media ${devices.phoneLg} {
      height: auto;
    }

    img {
      width: 100%;
      height: auto;
    }
  }

  .card__info {
    display: flex;
    align-items: center;

    &.main {
      margin-top: 20px;
      justify-content: space-between;

      .info {
        display: flex;
        align-items: center;
      }
    }

    .date {
      font-size: 14px;
      font-weight: 300;
      color: var(--light-grey);
    }
  }

  .card__title {
    color: var(--white);
    margin: 10px 0;
    transition: color 0.3s ease;
    font-size: 3.1rem;
    text-transform: none;
    margin-bottom: 0;
    letter-spacing: 0;
  }

  a {
    font-weight: 400;

    &:hover {
      .card__title {
        color: var(--primary-on-hover);
      }
    }
  }
  
 
`;